import { component$, type PropsOf } from "@builder.io/qwik";
import { Badge } from "./ui/badge";
import { MembershipPlan } from "~/lib/schemas";
import { LuSparkle, LuSparkles } from "@qwikest/icons/lucide";
import { Slot } from "@builder.io/qwik";

export const PLAN_LABELS: Record<MembershipPlan, string> = {
  [MembershipPlan.Standard]: "Standard",
  [MembershipPlan.Pro]: "Pro",
  [MembershipPlan.ProPlus]: "Pro+",
};

export const PlanBadge = component$<
  {
    membershipPlan: MembershipPlan;
  } & PropsOf<"div">
>(({ membershipPlan, ...props }) => (
  <Badge
    {...props}
    radius="rounded"
    variant={membershipPlan === MembershipPlan.Standard ? "gray" : "pro"}
  >
    {membershipPlan === MembershipPlan.Pro && <LuSparkle />}
    {membershipPlan === MembershipPlan.ProPlus && <LuSparkles />}
    {PLAN_LABELS[membershipPlan]}
    <Slot />
  </Badge>
));
